import { makePropertySelector } from 'store/utils';

const getPropertySelector = makePropertySelector('auth');

/** @deprecated see {getAccount} instead */
export const getAccountId = getPropertySelector('accountId');
export const getIsAuthenticated = getPropertySelector('isAuthenticated');
export const getIsSessionInvalid = getPropertySelector('isSessionInvalid');
export const getAccount = getPropertySelector('account');
export const getUserAccountProfile = getPropertySelector('userAccountProfile');
